// Copyright (c) 2020 Deere & Company

import * as fetchService from '../../../shared/services/fetch';
import { getBasePath } from '../../../shared/services/get-base-path';
import { handleError } from '../../../shared/services/error-handlers';

const basePath = getBasePath();

export async function getOrderConstraintBuildWeek ( constraintType,
    constraintKey, beginWeek, endWeek ) {

    const endPoint = `${basePath}/orderconstraint-report`;
    const payLoad = {
        constraintType,
        constraintKey,
        beginWeek,
        endWeek
    };

    const options = {
        body: JSON.stringify( payLoad ),
        headers: {'Content-Type': 'application/json'},
        method: 'POST'
    };

    try {

        const response = await fetchService.fetch( endPoint, options );

        return response.json();

    } catch ( error ) {

        return handleError( error );
        //  throw error;

    }

}

export async function getOrderConstraintExcel ( constraintType,
    constraintKey, beginWeek, endWeek ) {

    const endPoint = `${basePath}/excelorderconstraint-report`;
    const payLoad = {
        constraintType,
        constraintKey,
        beginWeek,
        endWeek
    };

    const options = {
        body: JSON.stringify( payLoad ),
        headers: {'Content-Type': 'application/json'},
        method: 'POST'
    };

    try {

        const response = await fetchService.fetch( endPoint, options );

        return response;

    } catch ( error ) {

        return handleError( error );

    }

}
